import React, { Component } from 'react'
import { Message } from 'semantic-ui-react'
import PropTypes from 'prop-types'

export default class Alert extends Component {

  static propTypes = {
    color: PropTypes.string,
    messages: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    onClose: PropTypes.func,
    header: PropTypes.string
  }

  constructor (props) {
    super(props)

    this.state = {
      visible: !!props.messages,
      type: props.type,
      messages: props.messages
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.messages !== nextProps.messages ||
        this.props.type !== nextProps.type) {
      this.setState({
        messages: nextProps.messages,
        type: nextProps.type,
        visible: !!nextProps.messages
      })
    }
  }

  handleDismiss = () => {
    this.setState({visible: false})
  }

  render () {
    if (!this.state.visible) return null
    return (
      <Message
        visible={this.state.visible}
        color={this.props.color}
        onDismiss={this.handleDismiss}>
          {this.props.header &&
            <Message.Header>{this.props.header}</Message.Header>
          }
          {Array.isArray(this.props.messages)
            ? <Message.List items={this.props.messages} />
            : <Message.Content>{this.props.messages}</Message.Content>
          }
      </Message>
    )
  }
}




// WEBPACK FOOTER //
// ./src/Components/Alert.js